module.exports = __webpack_public_path__ + "img/20200922_093331.c61cf7bd.jpg";